import React from "react";
import {Carousel, Image} from "react-bootstrap";
import "animate.css";

const sliderImages = [
    "/images/hotel.jpg",
    "/images/catering.jpg",
    "/images/restaurant.jpg",
    "/images/sliderlobe4.jpg",
    "/images/sliderlobe5.jpg",
    "/images/sliderlobe6.jpg"
];

const sliderVideos = [
    {url: "/videos/01_Sin_audio36.webm", interval: 54000},
    //{url: "/videos/02_Sin_audio40.webm", interval: 40000},
    //{url: "/videos/03_Sin_audio40.webm", interval: 41000},
    //{url: "/videos/04_Sin_audio40.webm", interval: 45000},
];

const MainSlider: React.FC = () => {
    const openWhatsapp = () => {
        window.open("https://wa.me/529992512337", "_blank");
    }

    return (
        <Carousel id="home" interval={5000} touch={true} fade controls={false} indicators={true} className="h-100">
            {
                sliderVideos.map((video, index) =>
                    <Carousel.Item interval={video.interval}>
                        <div className="video-container">
                            <video
                                autoPlay
                                muted
                                loop
                                playsInline
                                preload="none"
                                className="video-fullscreen">
                                <source src={video.url} type="video/webm"/>
                            </video>
                        </div>
                    </Carousel.Item>
                )
            }
            {
                sliderImages.map((image, index) => (
                    <Carousel.Item key={index}>
                        <div className="video-container">
                            <Image
                                fluid
                                src={image}
                                alt="Poma1"
                                className="video-fullscreen"
                            />
                        </div>
                        <div className="logo-slider position-br">
                            <img src="/images/LOGOBLANCO.png" className="logo-poma-slider" alt="LOGO"/>
                        </div>
                    </Carousel.Item>
                ))
            }
        </Carousel>
    )
}

export default MainSlider;